import AssetList from './AssetList';

const Extras = () => {
  return (
    <div className="extras-list">
      <AssetList title="Trailers" linkedAssetType="Trailer" />
      <AssetList title="Extras" linkedAssetType="Extra" />
    </div>
  );
};

export default Extras;
